/*
  VOLT product card behaviour (snippets/volt-product-card.liquid).
  - Colour dots swap the card photo to that colour and remember the choice.
  - The card button adds a one-variant product straight to the cart. Anything
    with options opens one shared panel (a dialog: centred on desktop, a bottom
    sheet on a phone) with the colour already picked from the card, then adds
    the chosen variant and re-renders the theme's cart drawer.
*/
(() => {
  if (window.voltCardReady) return;
  window.voltCardReady = true;

  const money = (cents) => {
    // The visitor's currency, as the money filter prints it (audit 22 Oct: Shopify.money_format does not exist, so it was always £).
    const sample = window.voltMoneySample || '\u00a31.00';
    const amount = (cents / 100).toFixed(2);
    return sample.replace(/1[.,]00/, /1,00/.test(sample) ? amount.replace('.', ',') : amount);
  };

  async function addToCart(id) {
    const drawer = document.querySelector('cart-drawer');
    const sections = drawer && typeof drawer.getSectionsToRender === 'function' ? drawer.getSectionsToRender().map((s) => s.id) : [];
    const base = (window.routes && window.routes.cart_add_url) || '/cart/add';
    const res = await fetch(base + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id, quantity: 1 }], sections, sections_url: window.location.pathname }),
    });
    let json = {};
    try { json = await res.json(); } catch (e) { throw new Error('Could not add to cart. Please try again.'); }
    if (!res.ok || json.status) throw new Error(json.description || json.message || 'Could not add to cart.');
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'volt-card', productVariantId: id, cartData: json });
    }
    if (drawer && json.sections) { drawer.classList.remove('is-empty'); drawer.renderContents(json, true); }
    else window.location = (window.routes && window.routes.cart_url) || '/cart';
  }

  // Shared with the homepage buy hero (sections/home-buy-hero-volt.liquid).
  window.voltAddToCart = addToCart;

  // ---------- Colour dots ----------
  document.addEventListener('click', (e) => {
    const dot = e.target.closest('.vcard__dot');
    if (!dot) return;
    const card = dot.closest('[data-volt-card]');
    card.querySelectorAll('.vcard__dot').forEach((d) => d.setAttribute('aria-pressed', d === dot ? 'true' : 'false'));
    card.dataset.colour = dot.dataset.colour;
    const img = card.querySelector('.vcard__img');
    if (img && dot.dataset.img) { img.removeAttribute('srcset'); img.src = dot.dataset.img; }
    // The hover photo follows the colour too: the image after that colour's photo, or none.
    const img2 = card.querySelector('.vcard__img2');
    if (img2) {
      if (dot.dataset.img2) { img2.removeAttribute('srcset'); img2.src = dot.dataset.img2; img2.hidden = false; }
      else img2.hidden = true;
    }
  });

  // ---------- Quick add panel ----------
  let dlg, state;
  function panel() {
    if (dlg) return dlg;
    dlg = document.createElement('dialog');
    dlg.className = 'vqa';
    dlg.setAttribute('aria-labelledby', 'vqa-title');
    dlg.innerHTML = '<div class="vqa__in"><div class="vqa__head"><h2 class="vqa__title" id="vqa-title"></h2><button type="button" class="vqa__close" aria-label="Close">×</button></div><div class="vqa__opts"></div><p class="vqa__err" role="alert"></p><button type="button" class="vqa__add"></button><a class="vqa__link" href="#">View full details</a></div>';
    document.body.appendChild(dlg);
    dlg.querySelector('.vqa__close').addEventListener('click', () => dlg.close());
    dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
    dlg.querySelector('.vqa__opts').addEventListener('click', (e) => {
      const b = e.target.closest('.vqa__val');
      if (!b || b.disabled) return;
      state.picked[Number(b.dataset.i)] = b.dataset.v;
      draw();
    });
    dlg.querySelector('.vqa__add').addEventListener('click', async () => {
      const v = match();
      if (!v) return;
      const btn = dlg.querySelector('.vqa__add');
      btn.disabled = true; btn.textContent = 'Adding…';
      try { await addToCart(v.id); dlg.close(); }
      catch (err) { dlg.querySelector('.vqa__err').textContent = err.message; btn.disabled = false; draw(); }
    });
    return dlg;
  }

  function match() {
    return state.data.variants.find((v) => v.available && v.options.every((o, i) => state.picked[i] === o));
  }

  function draw() {
    const d = state.data;
    const opts = dlg.querySelector('.vqa__opts');
    opts.innerHTML = '';
    d.options.forEach((name, i) => {
      const vals = [...new Set(d.variants.map((v) => v.options[i]))];
      if (vals.length < 2) { state.picked[i] = vals[0]; return; }
      const fs = document.createElement('fieldset');
      fs.className = 'vqa__opt';
      const lg = document.createElement('legend');
      lg.textContent = (/size/i.test(name) ? 'Size' : name) + (state.picked[i] ? ': ' + state.picked[i] : '');
      fs.appendChild(lg);
      const wrap = document.createElement('div');
      wrap.className = 'vqa__vals';
      vals.forEach((val) => {
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'vqa__val'; b.textContent = val; b.dataset.i = i; b.dataset.v = val;
        b.setAttribute('aria-pressed', state.picked[i] === val ? 'true' : 'false');
        const possible = d.variants.some((v) => v.available && v.options[i] === val && v.options.every((o, j) => j === i || !state.picked[j] || state.picked[j] === o));
        if (!possible) b.disabled = true;
        wrap.appendChild(b);
      });
      fs.appendChild(wrap);
      opts.appendChild(fs);
    });
    const v = match();
    const add = dlg.querySelector('.vqa__add');
    const missing = d.options.map((n, i) => (state.picked[i] ? null : (/size/i.test(n) ? 'size' : n.toLowerCase()))).filter(Boolean);
    add.disabled = !v;
    add.textContent = v ? 'Add to cart · ' + money(v.price) : (missing.length ? 'Choose ' + missing[0] : 'Unavailable');
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    const card = btn.closest('[data-volt-card]');
    const data = JSON.parse(card.querySelector('[data-card-json]').textContent);
    if (data.variants.length === 1) {
      const label = btn.textContent;
      btn.classList.add('is-busy'); btn.disabled = true;
      try { await addToCart(data.variants[0].id); btn.textContent = 'Added ✓'; setTimeout(() => { btn.textContent = label; }, 1800); }
      catch (err) { btn.textContent = 'Try again'; }
      finally { btn.classList.remove('is-busy'); btn.disabled = false; }
      return;
    }
    panel();
    state = { data, picked: {} };
    if (data.colour >= 0 && card.dataset.colour) state.picked[data.colour] = card.dataset.colour;
    else if (data.colour >= 0) {
      const first = card.querySelector('.vcard__dot[aria-pressed="true"]');
      if (first) state.picked[data.colour] = first.dataset.colour;
    }
    dlg.querySelector('.vqa__title').textContent = data.title;
    dlg.querySelector('.vqa__link').href = btn.dataset.url;
    dlg.querySelector('.vqa__err').textContent = '';
    draw();
    dlg.showModal();
  });
})();
